/* eslint-disable no-underscore-dangle */
import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

class ProdutoRequest extends CrudRequest {
  static baseUrl() {
    return '/produto-servico';
  }

  static edit(id, payload) {
    return httpService.put(`${this.baseUrl()}/${id}`, payload);
  }

  static get(id) {
    return httpService.get(`${this.baseUrl()}/${id}`);
  }

  static list(queryParams = {}) {
    return httpService.get(`${this.baseUrl()}/list-all`, {
      params: queryParams,
    });
  }

  static remove(id) {
    return httpService.delete(`${this.baseUrl()}/${id}`);
  }

  static save(payload) {
    return httpService.post(`${this.baseUrl()}/add`, payload);
  }

  static addFornecedor(idFornecedor, produtoId) {
    return httpService.post(`${this.baseUrl()}/add-list-produto-fornecedor/${idFornecedor}`, [
      {
        idProdutoServico: produtoId,
      },
    ]);
  }

  static listFornecedores(id, params = {}) {
    return httpService.get(`${this.baseUrl()}/${id}/all-fornecedores`, {
      params,
    });
  }

  static upload(id, file) {
    return this.makeFormDataRequest(
      `${this.baseUrl()}/${id}/addLogo`,
      {
        imageLogo: file,
      },
    );
  }

  static removeFornecedores(id, fornecedoresIds) {
    const url = `${this.baseUrl()}/removerFornecedor/${id}`;
    httpService.interceptors.request.use((request) => {
      const config = request;

      if (config.url === url) {
        config.data = fornecedoresIds;
      }

      return config;
    });

    return httpService.delete(url, {
      data: fornecedoresIds,
    });
  }
}

export default ProdutoRequest;
